import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '../Accordion/Accordion';
import AccordionItem from '../Accordion/AccordionItem';
import Address from '../Address/Address';
import { useHistory } from 'react-router-dom';
import useMode from '../../hooks/useMode';
import { format } from 'date-fns';
import { JobWithRwInspection } from './RecycledWaterInspectionThirdPane';

type RecycledWaterInspectionDetailProps = {
  job: JobWithRwInspection;
  onChange?: () => void;
};

const RecycledWaterInspectionDetail: React.FC<
  RecycledWaterInspectionDetailProps
> = ({ job, onChange }) => {
  const history = useHistory();
  const mode = useMode();

  return (
    <>
      <Accordion title="Details">
        {/*  <AccordionItem*/}
        {/*    kind="chip"*/}
        {/*    status={waterSiteStatusStyle(waterSite.status)}*/}
        {/*    label="Status"*/}
        {/*    value={constantToLabel(waterSite.status)}*/}
        {/*  />*/}
        <AccordionItem
          label="Name"
          value={job.recycledWaterInspection?.waterSite.name}
        />
        <AccordionItem
          label="Address"
          value={<Address address={job.address} />}
        />
        {job.scheduled && (
          <AccordionItem
            label="Scheduled"
            value={format(job.scheduled, 'M/d/yyyy')}
          />
        )}
      </Accordion>
      {job.recycledWaterInspection.contact && (
        <Accordion title="Contact">
          <AccordionItem
            label="Name"
            value={`${job.recycledWaterInspection.contact.firstName} ${job.recycledWaterInspection.contact.lastName}`}
          />
          {job.recycledWaterInspection.contact.phones.length > 0 && (
            <AccordionItem
              label="Phone"
              value={job.recycledWaterInspection.contact.phones[0].value}
            />
          )}
          {job.recycledWaterInspection.contact.emails.length > 0 && (
            <AccordionItem
              label="Email"
              value={job.recycledWaterInspection.contact.emails[0].value}
            />
          )}
        </Accordion>
      )}
      {job.recycledWaterInspection.supervisor && (
        <Accordion title="Supervisor">
          <AccordionItem
            label="Name"
            value={`${job.recycledWaterInspection.supervisor.firstName} ${job.recycledWaterInspection.supervisor.lastName}`}
          />
          {job.recycledWaterInspection.supervisor.phones.length > 0 && (
            <AccordionItem
              label="Phone"
              value={job.recycledWaterInspection.supervisor.phones[0].value}
            />
          )}
          {job.recycledWaterInspection.supervisor.emails.length > 0 && (
            <AccordionItem
              label="Email"
              value={job.recycledWaterInspection.supervisor.emails[0].value}
            />
          )}
        </Accordion>
      )}
      {/*{waterSite.assignedTo && (*/}
      {/*  <Accordion title="Assigned to">*/}
      {/*    <AccordionItem*/}
      {/*      label="Name"*/}
      {/*      value={`${waterSite.assignedTo.firstName} ${waterSite.assignedTo.lastName}`}*/}
      {/*    />*/}
      {/*    {waterSite.assignedTo.phones.length > 0 && (*/}
      {/*      <AccordionItem*/}
      {/*        label="Phone"*/}
      {/*        value={waterSite.assignedTo.phones[0].value}*/}
      {/*      />*/}
      {/*    )}*/}
      {/*    {waterSite.assignedTo.emails.length > 0 && (*/}
      {/*      <AccordionItem*/}
      {/*        label="Phone"*/}
      {/*        value={waterSite.assignedTo.emails[0].value}*/}
      {/*      />*/}
      {/*    )}*/}
      {/*  </Accordion>*/}
      {/*)}*/}
    </>
  );
};

RecycledWaterInspectionDetail.propTypes = {
  job: PropTypes.any,
};

export default RecycledWaterInspectionDetail;
